import React, { useContext } from 'react'
const DirectClaimContext = React.createContext({})
export const DirectClaimProvider = DirectClaimContext.Provider
export default DirectClaimContext

export function useDirectClaimContext (){
    const data = useContext(DirectClaimContext)
    return data
}